/**
 * 学习乐园 · 排排序题材包：节气排序（paixu/pack-jieqi.js）
 * ---------------------------------------------------------------------------
 * 收二十四节气里的十二个「节」（立春、惊蛰、清明……大雪、小寒）——
 * 即每个公历月月初的那一个，两公历月里「一节一中气」。十二个「中气」
 * （雨水、春分、夏至、秋分、霜降、大寒）不混进来：一局 24 张偏长，
 * 先把「两月一节」的主线排顺，doc 页如实说明口径。
 * 十二个「节」再每局随机抽八个（4×2）上场——多玩几局凑齐整条年轮。
 * 排序从立春起、小寒收——小寒在公历 1 月，属于次年的开头，
 * 排完一圈正好绕回立春，这是节气按「年轮」排的本义。
 * note 讲节气含义与农事，清明「既是节日又是节气」这类常考点也带上。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.jieqi = {
    id: 'jieqi',
    name: '节气排序',
    hint: '每局抽八个「节」按一年先后排',
    cols: 4,
    draw: 8,
    winText: '立春惊蛰清明立夏芒种小暑，立秋白露寒露立冬大雪小寒——两个公历月里一节一中气，排完正好绕回立春。',
    items: [
      { face: '立春', note: '二十四节气从头起，春天从这一天算起' },
      { face: '惊蛰', note: '春雷一响，蛰伏的虫子被惊醒' },
      { face: '清明', note: '既是扫墓踏青的节日，又是节气' },
      { face: '立夏', note: '夏天从这一天算起' },
      { face: '芒种', note: '麦子快收、稻子可种，农事最忙' },
      { face: '小暑', note: '天开始热，还没热到头' },
      { face: '立秋', note: '秋天从这一天算起' },
      { face: '白露', note: '夜里转凉，草木上凝出露水' },
      { face: '寒露', note: '露水带着寒气，冬天不远了' },
      { face: '立冬', note: '冬天从这一天算起' },
      { face: '大雪', note: '开始纷纷扬扬下大雪' },
      { face: '小寒', note: '一年里最冷的日子，排完正好绕回立春' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
